import { baseApi } from "../app-main/store/baseApi";

export type HostPotentialPayoutResponse = {
  potential_payout: number;
  currency?: string;
};

export const contractsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getHostPotentialPayout: builder.query<HostPotentialPayoutResponse, void>({
      query: () => ({
        url: "/v1/contracts/host/potential_payout",
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetHostPotentialPayoutQuery } = contractsApi;
